export { default } from './ColumnChartWidgetBar';
